export const baseUrl = "/";
export const customersUrl = "/dine-kunder";
export const customerInfoUrl = "/kunde";
export const resetPasswordUrl = "/reset-passord";
export const enterCodeUrl = "/bekreft-kode";
export const createNewPasswordUrl = "/nytt-passord";
